const KNOWN_STATUSES = [
  "incomplete",
  "completed",
  "incomplete_expired",
  "trialing",
  "active",
  "past_due",
  "canceled",
  "unpaid",
];

/**
 * Human-readable Fansbury/Reva subscription status for Gestión UI.
 */
export function formatSubscriptionStatus(intl, status) {
  if (!status) {
    return intl.formatMessage({ id: "gestion.subscriptionStatus.unknown" });
  }

  if (KNOWN_STATUSES.includes(status)) {
    return intl.formatMessage({ id: `gestion.subscriptionStatus.${status}` });
  }

  return intl.formatMessage({ id: "gestion.subscriptionStatus.other" }, { status });
}
